import app from './app';
import initSA from './auth/initSA';
import signin from './auth/signin';
import page from './page';
import test from './test';
import loading from './util/loading';

export default {
    app,initSA,signin,page,loading,test
}